



















import { Vue, Component, Prop } from 'vue-property-decorator';
import { CatLink, CatLinkObject } from '@/models/Complement';

@Component
export default class Complement extends Vue {
    private show: boolean = false;
    private categoryLinksObject!: CatLinkObject;
    private categoryLinks!: Array<CatLink>;

    constructor() {
        super();
     
        this.categoryLinksObject = JSON.parse(this.$attrs['data-category-links']) as CatLinkObject;
      
    }
    mounted() {
        this.$root.$on('show-complement', () => {
            this.show = true;
            setTimeout(() => {
                this.$el.scrollIntoView({ behavior: 'smooth' });
            }, 1500);
        });
    }
}
